import React from 'react'
import { useHistory } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import DashboardIcon from '@material-ui/icons/Dashboard'
import MapIcon from '@material-ui/icons/Map'
import BarChartIcon from '@material-ui/icons/BarChart'
import SettingsCellIcon from '@material-ui/icons/SettingsCell'
import AssignmentIcon from '@material-ui/icons/Assignment'
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna'
import EditNotificationsIcon from '@material-ui/icons/NotificationsActive'
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import InfoIcon from '@material-ui/icons/Info'
import { Assignment, PhoneAndroid, Place, SettingsInputAntenna } from '@material-ui/icons'
import SearchIcon from '@material-ui/icons/Search'

export const MainListItems = props => {
    const history = useHistory()
    return (
        <div>
            <ListItem button onClick={() => history.push('/dashboard')}>
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
            </ListItem>
            <ListItem button onClick={() => history.push('/heatmap')}>
                <ListItemIcon>
                    <MapIcon />
                </ListItemIcon>
                <ListItemText primary="Map" />
            </ListItem>
            <ListItem button onClick={() => history.push('/devices')}>
                <ListItemIcon>
                    <SettingsCellIcon />
                </ListItemIcon>
                <ListItemText primary="Devices" />
            </ListItem>
            <ListItem button onClick={() => history.push('/base-stations')}>
                <ListItemIcon>
                    <SettingsInputAntennaIcon />
                </ListItemIcon>
                <ListItemText primary="Base Stations" />
            </ListItem>
            <ListItem button onClick={() => history.push('/search')}>
                <ListItemIcon>
                    <SearchIcon />
                </ListItemIcon>
                <ListItemText primary="Search KPI" />
            </ListItem>
            <ListItem button onClick={() => history.push('/tickets')}>
                <ListItemIcon>
                    <Assignment />
                </ListItemIcon>
                <ListItemText primary="Tickets" />
            </ListItem>
            <ListItem button onClick={() => history.push('/forceRoaming')}>
                <ListItemIcon>
                    <PhoneAndroid />
                </ListItemIcon>
                <ListItemText primary="Force Roaming" />
            </ListItem>
            <ListItem button onClick={() => history.push('/bsConnected')}>
                <ListItemIcon>
                    <SettingsInputAntenna />
                </ListItemIcon>
                <ListItemText primary="Base Stations Connected" />
            </ListItem>
            <ListItem button onClick={() => history.push('/geofencing')}>
                <ListItemIcon>
                    <Place />
                </ListItemIcon>
                <ListItemText primary="Geofencing" />
            </ListItem>
            <ListItem button onClick={() => history.push('/notifications')}>
                <ListItemIcon>
                    <EditNotificationsIcon />
                </ListItemIcon>
                <ListItemText primary="Notifications" />
            </ListItem>
            <ListItem button onClick={() => history.push('/incidents')}>
                <ListItemIcon>
                    <DonutSmallIcon />
                </ListItemIcon>
                <ListItemText primary="Incidents" />
            </ListItem>
            <ListItem button onClick={() => history.push('/useapps')}>
                <ListItemIcon>
                    <InsertChartIcon />
                </ListItemIcon>
                <ListItemText primary="Use Apps" />
            </ListItem>
            <ListItem button onClick={() => history.push('/reports')}>
                <ListItemIcon>
                    <BarChartIcon />
                </ListItemIcon>
                <ListItemText primary="Reports" />
            </ListItem>
            <ListItem button onClick={() => history.push('/about')}>
                <ListItemIcon>
                    <InfoIcon />
                </ListItemIcon>
                <ListItemText primary="About" />
            </ListItem>
        </div>
    )
}

export const secondaryListItems = (
    <div>
        <ListSubheader inset>Saved reports</ListSubheader>
        <ListItem button>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Current month" />
        </ListItem>
        <ListItem button>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Last quarter" />
        </ListItem>
        <ListItem button>
            <ListItemIcon>
                <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Year-end sale" />
        </ListItem>
    </div>
)
